import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'

export const RolesPermissionsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.roles_permissions}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({ path: ConversationRoutes.root })
      }}
    />
  )
})
